// Front/src/utils/scaleFormValidation.js

export const isPositiveNumber = (value) => {
    // Check if the value is a positive number
    return value !== "" && !isNaN(value) && Number(value) >= 0;
};

export const validateScaleData = (formData, t) => {
    if (!formData.serialNumber.trim()) {
        return t.scale_serial_required;
    }
    if (!formData.internalId.trim()) {
        return t.scale_internal_id_required;
    }
    if (!formData.clientId.trim()) {
        return t.scale_client_id_required;
    }
    if (!formData.catalogNumber.trim()) {
        return t.scale_catalog_required;
    }
    if (!isPositiveNumber(formData.maxValue)) {
        return t.scale_max_invalid;
    }
    if (!isPositiveNumber(formData.minValue)) {
        return t.scale_min_invalid;
    }
    if (!isPositiveNumber(formData.dValue)) {
        return t.scale_d_invalid;
    }
    if (!isPositiveNumber(formData.eValue)) {
        return t.scale_e_invalid;
    }
    if (!isPositiveNumber(formData.nValue)) {
        return t.scale_n_invalid;
    }
    if (!String(formData.accuracyClass).trim()) {
        return t.scale_accuracy_required;
    }
    if (!String(formData.weightUnits).trim()) {
        return t.scale_weight_units_required;
    }

    // Validate that eValue >= dValue
    const d = parseFloat(formData.dValue);
    const e = parseFloat(formData.eValue);
    if (!isNaN(d) && !isNaN(e) && e < d) {
        return t.eLowerThanD;
    }

    return null;
};
